/**
 * Fase 2 (W19, K4): textos da marca de inadimplência derivada do Contas (decisão 15 do plano), usada no Cadastros (lista e
 * ficha) e no Contas (aviso ao emitir a fatura). No núcleo porque os dois módulos mostram a mesma frase.
 */
export const inadimplenciaPt = {
  inadimplencia: {
    selo: 'Inadimplente',
    rotulo: 'Inadimplência',
    faturas_one: '{{count}} fatura vencida',
    faturas_other: '{{count}} faturas vencidas',
    atraso_one: 'a mais antiga há {{count}} dia',
    atraso_other: 'a mais antiga há {{count}} dias',
    verTitulos: 'Ver os títulos',
    aviso: 'Cliente inadimplente: {{detalhe}}. A emissão não é bloqueada.',
  },
};

export const inadimplenciaEn: typeof inadimplenciaPt = {
  inadimplencia: {
    selo: 'Overdue',
    rotulo: 'Overdue payments',
    faturas_one: '{{count}} overdue invoice',
    faturas_other: '{{count}} overdue invoices',
    atraso_one: 'the oldest {{count}} day late',
    atraso_other: 'the oldest {{count}} days late',
    verTitulos: 'See the bills',
    aviso: 'Customer with overdue payments: {{detalhe}}. Issuing is not blocked.',
  },
};

export const inadimplenciaEs: typeof inadimplenciaPt = {
  inadimplencia: {
    selo: 'Moroso',
    rotulo: 'Morosidad',
    faturas_one: '{{count}} factura vencida',
    faturas_other: '{{count}} facturas vencidas',
    atraso_one: 'la más antigua con {{count}} día de atraso',
    atraso_other: 'la más antigua con {{count}} días de atraso',
    verTitulos: 'Ver los títulos',
    aviso: 'Cliente moroso: {{detalhe}}. La emisión no se bloquea.',
  },
};
